import styled from 'styled-components'
import CommonStyledLink from '../../common/styled/StyledLink'

export const StyledLink = styled(CommonStyledLink)`
    &:hover {
        color: #fff;
    }
`
